import React from 'react';
import { useModal, useNotification } from '@hooks';
import ChangePasswordForm from '../components/ProfileForm/components/ChangePasswordForm';

export const useChangePasswordModal = () => {
    const notification = useNotification();
    const { open, close } = useModal();

    const showChangePasswordModal = () => {
        open({
            title: <span data-e2e='profile_change-password-modal_title'>Change password</span>,
            content: (
                <ChangePasswordForm
                    onClose={() => {
                        notification.success({
                            message: (
                                <span data-e2e='profile_password-changed_notification'>
                                    Your new password has been saved successfully
                                </span>
                            ),
                            description: ''
                        });

                        close();
                    }}
                />
            ),
            settings: { maskClosable: false }
        });
    };

    return { showChangePasswordModal, close };
};
